import { render, staticRenderFns } from "./RepresentationCard.vue?vue&type=template&id=1a7b063f&"
import script from "./RepresentationCard.vue?vue&type=script&lang=js&"
export * from "./RepresentationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports